export type SelectOption = {
	label: string;
	value: string;
};

const normalizeQueryValue = (value: string | null): string | null => {
	if (value === null) {
		return null;
	}

	const trimmedValue = value.trim();
	if (!trimmedValue || trimmedValue.toLowerCase() === 'null' || trimmedValue.toLowerCase() === 'undefined') {
		return null;
	}

	return trimmedValue;
};

const uniqueValues = (values: string[]) => Array.from(new Set(values));

const parseQueryCodes = (searchParams: URLSearchParams, key: string): string[] => {
	const rawValues = searchParams.getAll(key);

	return uniqueValues(
		rawValues
			.flatMap((entry) => entry.split(','))
			.map((entry) => entry.trim())
			.filter((entry) => entry !== '' && entry.toLowerCase() !== 'null' && entry.toLowerCase() !== 'undefined')
	);
};

export const getPuntoVenditaOptions = (searchParams: URLSearchParams): SelectOption[] => {
	const availableCodes = parseQueryCodes(searchParams, 'availableCodes');
	const selectedCode = normalizeQueryValue(searchParams.get('puntoVendita'));
	const codes = selectedCode && !availableCodes.includes(selectedCode)
		? [...availableCodes, selectedCode]
		: availableCodes;

	return codes.map((code) => ({ label: code, value: code }));
};

export const getPuntoVenditaInitialValue = (searchParams: URLSearchParams): string => {
	const availableCodes = parseQueryCodes(searchParams, 'availableCodes');
	const selectedCode = normalizeQueryValue(searchParams.get('puntoVendita'));

	if (availableCodes.length === 1) {
		return availableCodes[0];
	}

	return selectedCode ?? '';
};

export const isPuntoVenditaDisabled = (searchParams: URLSearchParams): boolean => {
	return parseQueryCodes(searchParams, 'availableCodes').length === 1;
};
